import css from 'styled-jsx/css';
const styles = css.global `
  @import './style/global';
`;
export default styles;
